// @ts-expect-error Untyped Dependency
import { isFromVisitor } from 'conversations-message-history/common-message-format/operators/senderTypeComparators';
import { hasFeedbackRequestAttachment } from 'conversations-message-history/common-message-format/operators/hasFeedbackRequestAttachment';
export const shouldShowFeedback = ({
  isUngatedForCustomerAgentFeedback,
  isThreadClosed,
  isThreadHistoryLoaded,
  message
}) => isUngatedForCustomerAgentFeedback && isThreadHistoryLoaded && !isThreadClosed && !isFromVisitor(message) && hasFeedbackRequestAttachment(message);